import { z } from 'zod';

export const getMeasurementUnitsSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    code: z.string(),
  })
);

export type GetMeasurementUnits = z.infer<typeof getMeasurementUnitsSchema>;
